// eslint-disable-next-line max-classes-per-file
import { checkExistValue } from "@/utils/common/validateHelper/validateUtils";

import { CorporateDisCountPresenter } from "../../corporate/corporateServiceInterfaces/corporateInterface";
import {
  type PerkDataInterface,
  PerkDataPresenter,
} from "./getHotelAvailableInterface";

export interface RequestHotelRoomsAvailableInterface {
  hotelId: number;
  checkin: string;
  checkout: string;
  totalRoom: number;
  totalAdult: number;
  totalChild: number;
  roomKey?: string;
  childAge?: string;
  couponCode?: string;
}

export class ResponseHotelRoomAvailable {
  cache: boolean;

  group_user: string;

  roomAvailables: {
    roomKey: string;
    roomId: number;
    roomName: string;
    roomBoardName: string;
    currencyCode: string;
    price: number;
    priceWithoutVat: number;
    payAtHotel: boolean;
    payAtHotelPrice: number;
    payAtHotelCurrency: string;
    payAtHotelPaymentDetails: {
      payment_id: number;
      name: string;
    }[];
    payAtHotelExtraCharge: {
      type: string;
      amount: number;
      excluded: boolean;
      charge_amount: number;
      charge_price_mode: number;
      name: string;
      currency: string;
    }[];
    minAdult: number;
    maxAdult: number;
    minChild: number;
    maxChild: number;
    minRoom: number;
    maxRoom: number;
    cancellationPolicy: {
      date: string;
      chargeType: string;
      chargeAmount: number;
      currency: string;
    }[];
    cancellationPolicyDetail: string[];
    freeCancellation: number;
    manualGetCancellation: number;
    remark: string[];
    alert: string[];
    roomPriceNote: string[];
    specialDeal: {
      status: boolean;
      detail: string;
      perks?: {
        en: string[];
        th: string[];
      };
    };
    roomsLeft: number;
    roomSize: string;
    smokingRoom: string;
    roomAmenity: {
      id: number;
      name: string;
      name_en: string;
      groupId: number;
      groupName: string;
      isFree: boolean;
      isOnRequest: boolean;
      image: string;
    }[];
    roomPhoto: string[];
    extraChargeTotal: number;
    extraCharge: {
      amount: number;
      currency: string;
      excluded: boolean;
      name: string;
      type: string;
    }[];
    utmLandingPage: string;
    rackRateMarkup: number;
    rackRatePrice: number;
    rackRatepriceWithoutVat: number;
    isPayLater: number;
  }[];

  total: number;

  totalNonSmoking: number;

  totalPayAtHotel: number;

  totalFreeCancellation: number;

  totalCityView: number;

  keySearchTimeExpire: number;

  totalPayLater: number;

  perks: PerkDataInterface = {
    freebies: [],
    privileges: [],
  };

  constructor(data: any) {
    this.cache = data.cache || false;
    this.group_user = data.group_user || "";
    this.roomAvailables = (data.roomAvailables || []).map((item: any) => {
      return {
        roomKey: item.roomKey || "",
        roomId: item.roomId || 0,
        roomName: item.roomName || "",
        roomBoardName: item.roomBoardName || "",
        currencyCode: item.currencyCode || "",
        price: item.price || 0,
        vat: item.vat || 0,
        priceWithoutVat: item.priceWithoutVat || 0,
        payAtHotel: item.payAtHotel || false,
        payAtHotelPrice: item.payAtHotelPrice || 0,
        payAtHotelCurrency: item.payAtHotelCurrency || "",
        payAtHotelPaymentDetails: (item.payAtHotelPaymentDetails || []).map(
          (item_2: any) => {
            return {
              payment_id: item_2.payment_id || 0,
              name: item_2.name || "",
            };
          },
        ),
        payAtHotelExtraCharge: (item.payAtHotelExtraCharge || []).map(
          (item_2: any) => {
            return {
              type: item_2.type || "",
              amount: item_2.amount || 0,
              excluded: item_2.excluded || false,
              charge_amount: item_2.charge_amount || 0,
              charge_price_mode: item_2.charge_price_mode || 0,
              name: item_2.name || "",
              currency: item_2.currency || "",
            };
          },
        ),
        minAdult: item.minAdult || 0,
        maxAdult: item.maxAdult || 0,
        minChild: item.minChild || 0,
        maxChild: item.maxChild || 0,
        minRoom: item.minRoom || 0,
        maxRoom: item.maxRoom || 0,
        cancellationPolicy: (item.cancellationPolicy || []).map(
          (item_2: any) => {
            return {
              date: item_2.date || "",
              chargeType: item_2.chargeType || "",
              chargeAmount: item_2.chargeAmount || 0,
              currency: item_2.currency || "",
            };
          },
        ),
        cancellationPolicyDetail: item.cancellationPolicyDetail || "",
        freeCancellation: item.freeCancellation || 0,
        manualGetCancellation: item.manualGetCancellation || 0,
        remark: item.remark || "",
        alert: item.alert || "",
        roomPriceNote: item.roomPriceNote || [],
        specialDeal: {
          status: item.specialDeal?.status || false,
          detail: item.specialDeal?.detail || "",
          perks: {
            en:
              (item.specialDeal?.perks && item.specialDeal?.perks["en-us"]) ||
              [],
            th:
              (item.specialDeal?.perks && item.specialDeal?.perks["th-th"]) ||
              [],
          },
        },
        roomsLeft: item.roomsLeft || 0,
        roomSize: item.roomSize || "",
        smokingRoom: item.smokingRoom || "",
        roomAmenity: (item.roomAmenity || []).map((item_2: any) => {
          return {
            id: item_2.id || 0,
            name: item_2.name || "",
            name_en: item_2.name_en || "",
            groupId: item_2.groupId || 0,
            groupName: item_2.groupName || "",
            isFree: item_2.isFree || false,
            isOnRequest: item_2.isOnRequest || false,
            image: item_2.image || "",
          };
        }),
        roomPhoto: item.roomPhoto || "",
        extraChargeTotal: item.extraChargeTotal || 0,
        extraCharge: item.extraCharge || [
          {
            amount: 0,
            currency: "",
            excluded: false,
            name: "",
            type: "",
          },
        ],
        utmLandingPage: item.utmLandingPage || "",
        rackRateMarkup: item.rackRateMarkup || 0,
        rackRatePrice: item.rackRatePrice || 0,
        rackRatepriceWithoutVat: item.rackRatepriceWithoutVat || 0,
        isPayLater: item?.isPayLater || 0,
      };
    });
    this.total = data.total || 0;
    this.totalNonSmoking = data.totalNonSmoking || 0;
    this.totalPayAtHotel = data.totalPayAtHotel || 0;
    this.totalFreeCancellation = data.totalFreeCancellation || 0;
    this.totalCityView = data.totalCityView || 0;
    this.keySearchTimeExpire = data.keySearchTimeExpire || 0;
    this.totalPayLater = data?.totalPayLater || 0;
    this.perks = data?.perks ?? this.perks;
  }
}
export class PayAtHotelExtraChargePresenter {
  type: string;

  amount: number;

  excluded: boolean;

  charge_amount: number;

  charge_price_mode: number;

  name: string;

  currency: string;

  constructor(res: any) {
    this.type = res?.type || "";
    this.amount = res?.amount || 0;
    this.excluded = res?.excluded || false;
    this.charge_amount = res?.charge_amount || 0;
    this.charge_price_mode = res?.charge_price_mode || 0;
    this.name = res?.name || "";
    this.currency = res?.currency || "";
  }
}
export class CancellationPolicyPresenter {
  date: string;

  chargeType: string;

  chargeAmount: number;

  currency: string;

  constructor(res: any) {
    this.date = res?.date || "";
    this.chargeType = res?.chargeType || "";
    this.chargeAmount = res?.chargeAmount || 0;
    this.currency = res?.currency || "";
  }
}
export class LanguagePresenter {
  en: string[];

  th: string[];

  constructor(res: any) {
    this.en = res?.en || [];
    this.th = res?.th || [];
  }
}
export class SpecialDealPresenter {
  status: boolean;

  detail: string;

  perks?: LanguagePresenter;

  constructor(res: any) {
    this.status = res?.status || false;
    this.detail = res?.detail || "";
    this.perks = new LanguagePresenter(res?.perks);
  }
}
export class RoomAmenityPresenter {
  id: number;

  name: string;

  name_en: string;

  groupId: number;

  groupName: string;

  isFree: boolean;

  isOnRequest: boolean;

  image: string;

  constructor(res: any) {
    this.id = res?.id || 0;
    this.name = res?.name || "";
    this.name_en = res?.name_en || "";
    this.groupId = res?.groupId || 0;
    this.groupName = res?.groupName || "";
    this.isFree = res?.isFree || false;
    this.isOnRequest = res?.isOnRequest || false;
    this.image = res?.image || "";
  }
}
export class ExtraChargePresenter {
  amount: number;

  currency: string;

  excluded: boolean;

  name: string;

  type: string;

  constructor(res: any) {
    this.amount = res?.amount || 0;
    this.currency = res?.currency || "";
    this.excluded = res?.excluded || false;
    this.name = res?.name || "";
    this.type = res?.type || "";
  }
}
export class PayAtHotelPaymentDetailsPresenter {
  payment_id: number;

  name: string;

  constructor(res: any) {
    this.payment_id = res?.payment_id || 0;
    this.name = res?.name || "";
  }
}
export class RoomAvailablesPresenter extends CorporateDisCountPresenter {
  roomKey: string;

  roomId: number;

  roomName: string;

  roomBoardName: string;

  currencyCode: string;

  price: number;

  priceWithoutVat: number;

  payAtHotel: boolean;

  payAtHotelPrice: number;

  payAtHotelCurrency: string;

  payAtHotelPaymentDetails: PayAtHotelPaymentDetailsPresenter[];

  payAtHotelExtraCharge: PayAtHotelExtraChargePresenter[];

  minAdult: number;

  maxAdult: number;

  minChild: number;

  maxChild: number;

  minRoom: number;

  maxRoom: number;

  cancellationPolicy: CancellationPolicyPresenter[];

  cancellationPolicyDetail: string[];

  freeCancellation: number;

  manualGetCancellation: number;

  remark: string[];

  alert: string[];

  roomPriceNote: string[];

  specialDeal: {
    status: boolean;
    detail: string;
    perks?: {
      en: string[];
      th: string[];
    };
  };

  roomsLeft: number;

  vat: number;

  roomSize: string;

  smokingRoom: string;

  roomAmenity: RoomAmenityPresenter[];

  roomPhoto: string[];

  extraChargeTotal: number;

  extraCharge: ExtraChargePresenter[];

  utmLandingPage: string;

  rackRateMarkup: number;

  rackRatePrice: number;

  rackRatepriceWithoutVat: number;

  isPayLater: number;

  isAgodaPrice: boolean = false;

  constructor(res: any) {
    super(res);
    this.roomKey = res?.roomKey || "";
    this.roomId = res?.roomId || 0;
    this.vat = res?.vat || 0;
    this.roomName = res?.roomName || "";
    this.roomBoardName = res?.roomBoardName || "";
    this.currencyCode = res?.currencyCode || "";
    this.price = res?.price || 0;
    this.priceWithoutVat = res?.priceWithoutVat || 0;
    this.payAtHotel = res?.payAtHotel || false;
    this.payAtHotelPrice = res?.payAtHotelPrice || 0;
    this.payAtHotelCurrency = res?.payAtHotelCurrency || "";
    this.payAtHotelPaymentDetails =
      res?.payAtHotelPaymentDetails?.map(
        (item: PayAtHotelPaymentDetailsPresenter) =>
          new PayAtHotelPaymentDetailsPresenter(item),
      ) || [];
    this.payAtHotelExtraCharge =
      res?.payAtHotelExtraCharge?.map(
        (item: PayAtHotelExtraChargePresenter) =>
          new PayAtHotelExtraChargePresenter(item),
      ) || [];
    this.minAdult = res?.minAdult || 0;
    this.maxAdult = res?.maxAdult || 0;
    this.minChild = res?.minChild || 0;
    this.maxChild = res?.maxChild || 0;
    this.minRoom = res?.minRoom || 0;
    this.maxRoom = res?.maxRoom || 0;
    this.cancellationPolicy =
      res?.cancellationPolicy?.map(
        (item: CancellationPolicyPresenter) =>
          new CancellationPolicyPresenter(item),
      ) || [];
    this.cancellationPolicyDetail = res?.cancellationPolicyDetail || "";
    this.freeCancellation = res?.freeCancellation || 0;
    this.manualGetCancellation = res?.manualGetCancellation || 0;
    this.remark = res?.remark || "";
    this.alert = res?.alert || "";
    this.roomPriceNote = res?.roomPriceNote || [];
    // this.specialDeal = new SpecialDealPresenter(res?.specialDeal);
    this.specialDeal = {
      status: res.specialDeal?.status || false,
      detail: res.specialDeal?.detail || "",
      perks: {
        en: (res.specialDeal?.perks && res.specialDeal?.perks["en-us"]) || [],
        th: (res.specialDeal?.perks && res.specialDeal?.perks["th-th"]) || [],
      },
    };
    this.roomsLeft = res?.roomsLeft || 0;
    this.roomSize = res?.roomSize || "";
    this.smokingRoom = res?.smokingRoom || "";
    this.roomAmenity =
      res?.roomAmenity?.map(
        (item: RoomAmenityPresenter) => new RoomAmenityPresenter(item),
      ) || [];
    this.roomPhoto = res?.roomPhoto || "";
    this.extraChargeTotal = res?.extraChargeTotal || 0;
    this.extraCharge =
      res?.extraCharge?.map(
        (item: ExtraChargePresenter) => new ExtraChargePresenter(item),
      ) || [];
    this.utmLandingPage = res?.utmLandingPage || "";
    this.rackRateMarkup = res?.rackRateMarkup || 0;
    this.rackRatePrice = res?.rackRatePrice || 0;
    this.rackRatepriceWithoutVat = res?.rackRatepriceWithoutVat || 0;
    this.isPayLater = res?.isPayLater || 0;
    this.isAgodaPrice = checkExistValue(res?.isAgodaPrice);
  }
}

export class NewResponseHotelRoomAvailable {
  cache: boolean = false;

  group_user: string = "";

  roomAvailables: RoomAvailablesPresenter[] = [];

  total: number = 0;

  totalNonSmoking: number = 0;

  totalPayAtHotel: number = 0;

  totalFreeCancellation: number = 0;

  totalCityView: number = 0;

  keySearchTimeExpire: number = 0;

  totalPayLater: number = 0;

  perks: PerkDataInterface = {
    freebies: [],
    privileges: [],
  };

  constructor(data: any) {
    if (!data) return;
    this.cache = data.cache || false;
    this.group_user = data.group_user || "";
    this.roomAvailables =
      data.roomAvailables?.map(
        (item: RoomAvailablesPresenter) => new RoomAvailablesPresenter(item),
      ) || [];
    this.total = data.total || 0;
    this.totalNonSmoking = data.totalNonSmoking || 0;
    this.totalPayAtHotel = data.totalPayAtHotel || 0;
    this.totalFreeCancellation = data.totalFreeCancellation || 0;
    this.totalCityView = data.totalCityView || 0;
    this.keySearchTimeExpire = data.keySearchTimeExpire || 0;
    this.totalPayLater = data?.totalPayLater || 0;
    this.perks = new PerkDataPresenter(data?.perks);
  }
}
